import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { LayoutDashboardIcon, CalendarIcon, PrinterIcon, SearchIcon, TruckIcon } from 'lucide-react';
interface MISData {
  date: string;
  // Movement of Vehicles
  vehicleInYardPrevDay: number;
  billableVehicleForDays: number;
  totalBilledForDay: number;
  vehicleInYard: number;
  // Existing fields
  noOfEntry: number;
  noOfExit: number;
  noOfBilling: number;
  cashCollection: number;
  qrCollection: number;
  couponCollection: number;
  totalParkingAvailable: number;
  consumedArea: number;
  remainingParkingWard: number;
}
const mockData: MISData[] = [{
  date: '01/04/2026',
  vehicleInYardPrevDay: 120,
  billableVehicleForDays: 85,
  totalBilledForDay: 42,
  vehicleInYard: 125,
  noOfEntry: 45,
  noOfExit: 40,
  noOfBilling: 42,
  cashCollection: 12500,
  qrCollection: 8200,
  couponCollection: 3500,
  totalParkingAvailable: 500,
  consumedArea: 320,
  remainingParkingWard: 180
}, {
  date: '02/04/2026',
  vehicleInYardPrevDay: 125,
  billableVehicleForDays: 90,
  totalBilledForDay: 50,
  vehicleInYard: 129,
  noOfEntry: 52,
  noOfExit: 48,
  noOfBilling: 50,
  cashCollection: 15800,
  qrCollection: 9500,
  couponCollection: 4200,
  totalParkingAvailable: 500,
  consumedArea: 345,
  remainingParkingWard: 155
}, {
  date: '03/04/2026',
  vehicleInYardPrevDay: 129,
  billableVehicleForDays: 78,
  totalBilledForDay: 36,
  vehicleInYard: 132,
  noOfEntry: 38,
  noOfExit: 35,
  noOfBilling: 36,
  cashCollection: 10200,
  qrCollection: 7100,
  couponCollection: 2800,
  totalParkingAvailable: 500,
  consumedArea: 290,
  remainingParkingWard: 210
}, {
  date: '04/04/2026',
  vehicleInYardPrevDay: 132,
  billableVehicleForDays: 95,
  totalBilledForDay: 58,
  vehicleInYard: 137,
  noOfEntry: 60,
  noOfExit: 55,
  noOfBilling: 58,
  cashCollection: 18500,
  qrCollection: 11200,
  couponCollection: 5100,
  totalParkingAvailable: 500,
  consumedArea: 380,
  remainingParkingWard: 120
}, {
  date: '05/04/2026',
  vehicleInYardPrevDay: 137,
  billableVehicleForDays: 82,
  totalBilledForDay: 40,
  vehicleInYard: 141,
  noOfEntry: 42,
  noOfExit: 38,
  noOfBilling: 40,
  cashCollection: 11800,
  qrCollection: 7800,
  couponCollection: 3200,
  totalParkingAvailable: 500,
  consumedArea: 310,
  remainingParkingWard: 190
}, {
  date: '06/04/2026',
  vehicleInYardPrevDay: 141,
  billableVehicleForDays: 92,
  totalBilledForDay: 53,
  vehicleInYard: 146,
  noOfEntry: 55,
  noOfExit: 50,
  noOfBilling: 53,
  cashCollection: 16200,
  qrCollection: 10100,
  couponCollection: 4500,
  totalParkingAvailable: 500,
  consumedArea: 360,
  remainingParkingWard: 140
}, {
  date: '07/04/2026',
  vehicleInYardPrevDay: 146,
  billableVehicleForDays: 72,
  totalBilledForDay: 33,
  vehicleInYard: 149,
  noOfEntry: 35,
  noOfExit: 32,
  noOfBilling: 33,
  cashCollection: 9500,
  qrCollection: 6200,
  couponCollection: 2500,
  totalParkingAvailable: 500,
  consumedArea: 270,
  remainingParkingWard: 230
}, {
  date: '08/04/2026',
  vehicleInYardPrevDay: 149,
  billableVehicleForDays: 88,
  totalBilledForDay: 46,
  vehicleInYard: 153,
  noOfEntry: 48,
  noOfExit: 44,
  noOfBilling: 46,
  cashCollection: 14200,
  qrCollection: 8800,
  couponCollection: 3800,
  totalParkingAvailable: 500,
  consumedArea: 335,
  remainingParkingWard: 165
}, {
  date: '09/04/2026',
  vehicleInYardPrevDay: 153,
  billableVehicleForDays: 96,
  totalBilledForDay: 56,
  vehicleInYard: 158,
  noOfEntry: 58,
  noOfExit: 53,
  noOfBilling: 56,
  cashCollection: 17500,
  qrCollection: 10800,
  couponCollection: 4800,
  totalParkingAvailable: 500,
  consumedArea: 375,
  remainingParkingWard: 125
}, {
  date: '10/04/2026',
  vehicleInYardPrevDay: 158,
  billableVehicleForDays: 80,
  totalBilledForDay: 38,
  vehicleInYard: 162,
  noOfEntry: 40,
  noOfExit: 36,
  noOfBilling: 38,
  cashCollection: 11200,
  qrCollection: 7400,
  couponCollection: 3000,
  totalParkingAvailable: 500,
  consumedArea: 300,
  remainingParkingWard: 200
}, {
  date: '11/04/2026',
  vehicleInYardPrevDay: 162,
  billableVehicleForDays: 90,
  totalBilledForDay: 48,
  vehicleInYard: 166,
  noOfEntry: 50,
  noOfExit: 46,
  noOfBilling: 48,
  cashCollection: 14800,
  qrCollection: 9200,
  couponCollection: 4000,
  totalParkingAvailable: 500,
  consumedArea: 340,
  remainingParkingWard: 160
}, {
  date: '12/04/2026',
  vehicleInYardPrevDay: 166,
  billableVehicleForDays: 84,
  totalBilledForDay: 42,
  vehicleInYard: 170,
  noOfEntry: 44,
  noOfExit: 40,
  noOfBilling: 42,
  cashCollection: 12800,
  qrCollection: 8000,
  couponCollection: 3400,
  totalParkingAvailable: 500,
  consumedArea: 315,
  remainingParkingWard: 185
}, {
  date: '13/04/2026',
  vehicleInYardPrevDay: 170,
  billableVehicleForDays: 98,
  totalBilledForDay: 60,
  vehicleInYard: 174,
  noOfEntry: 62,
  noOfExit: 58,
  noOfBilling: 60,
  cashCollection: 19200,
  qrCollection: 11800,
  couponCollection: 5400,
  totalParkingAvailable: 500,
  consumedArea: 390,
  remainingParkingWard: 110
}, {
  date: '14/04/2026',
  vehicleInYardPrevDay: 174,
  billableVehicleForDays: 86,
  totalBilledForDay: 44,
  vehicleInYard: 178,
  noOfEntry: 46,
  noOfExit: 42,
  noOfBilling: 44,
  cashCollection: 13500,
  qrCollection: 8600,
  couponCollection: 3600,
  totalParkingAvailable: 500,
  consumedArea: 325,
  remainingParkingWard: 175
}, {
  date: '15/04/2026',
  vehicleInYardPrevDay: 178,
  billableVehicleForDays: 93,
  totalBilledForDay: 51,
  vehicleInYard: 182,
  noOfEntry: 53,
  noOfExit: 49,
  noOfBilling: 51,
  cashCollection: 16000,
  qrCollection: 9800,
  couponCollection: 4300,
  totalParkingAvailable: 500,
  consumedArea: 355,
  remainingParkingWard: 145
}];
export function MISReportPage() {
  const [startDate, setStartDate] = useState('2026-04-01');
  const [endDate, setEndDate] = useState('2026-04-15');
  const [hasGenerated, setHasGenerated] = useState(false);
  const totals = mockData.reduce((acc, row) => ({
    noOfEntry: acc.noOfEntry + row.noOfEntry,
    noOfExit: acc.noOfExit + row.noOfExit,
    noOfBilling: acc.noOfBilling + row.noOfBilling,
    cashCollection: acc.cashCollection + row.cashCollection,
    qrCollection: acc.qrCollection + row.qrCollection,
    couponCollection: acc.couponCollection + row.couponCollection,
    totalBilledForDay: acc.totalBilledForDay + row.totalBilledForDay,
    billableVehicleForDays: acc.billableVehicleForDays + row.billableVehicleForDays
  }), {
    noOfEntry: 0,
    noOfExit: 0,
    noOfBilling: 0,
    cashCollection: 0,
    qrCollection: 0,
    couponCollection: 0,
    totalBilledForDay: 0,
    billableVehicleForDays: 0
  });
  const grandTotal = totals.cashCollection + totals.qrCollection + totals.couponCollection;
  const handleGenerate = () => {
    setHasGenerated(true);
  };
  const handlePrint = () => {
    document.body.classList.add('print-a4');
    window.print();
    document.body.classList.remove('print-a4');
  };
  return <div className="w-full max-w-7xl mx-auto" data-id="element-775">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="bg-white rounded-2xl shadow-xl shadow-slate-200/50 border border-slate-100 p-5 xs:p-6 sm:p-8 no-print" data-id="element-776">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6" data-id="element-777">
          <div className="flex items-center gap-3" data-id="element-778">
            <div className="bg-brand-teal/10 p-2 rounded-xl border border-brand-teal/20" data-id="element-779">
              <LayoutDashboardIcon className="w-6 h-6 text-brand-teal" data-id="element-780" />
            </div>
            <div data-id="element-781">
              <h2 className="text-xl sm:text-2xl font-bold text-slate-900 tracking-tight" data-id="element-782">
                MIS Report
              </h2>
              <p className="text-sm text-slate-500" data-id="element-783">
                Daily management summary — vehicle movement, billing,
                collections & parking status.
              </p>
            </div>
          </div>
          {hasGenerated && <button onClick={handlePrint} className="inline-flex items-center justify-center gap-2 bg-brand-teal text-white px-4 py-2.5 rounded-xl font-medium text-sm hover:bg-brand-tealHover transition-colors" data-id="element-784">
              <PrinterIcon className="w-4 h-4" data-id="element-785" />
              Print Report
            </button>}
        </div>

        {/* Filters */}
        <div className="flex flex-col sm:flex-row gap-4 mb-8 p-4 bg-slate-50 rounded-xl border border-slate-200" data-id="element-786">
          <div className="flex-1" data-id="element-787">
            <label className="block text-xs font-semibold text-slate-500 mb-1.5" data-id="element-788">
              Start Date
            </label>
            <div className="relative" data-id="element-789">
              <CalendarIcon className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4.5 h-4.5 text-slate-400 pointer-events-none" data-id="element-790" />
              <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} className="w-full pl-10 pr-4 py-2.5 rounded-xl border border-slate-200 bg-white text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-brand-teal/30 focus:border-brand-teal transition-all" data-id="element-791" />
            </div>
          </div>
          <div className="flex-1" data-id="element-792">
            <label className="block text-xs font-semibold text-slate-500 mb-1.5" data-id="element-793">
              End Date
            </label>
            <div className="relative" data-id="element-794">
              <CalendarIcon className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4.5 h-4.5 text-slate-400 pointer-events-none" data-id="element-795" />
              <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} className="w-full pl-10 pr-4 py-2.5 rounded-xl border border-slate-200 bg-white text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-brand-teal/30 focus:border-brand-teal transition-all" data-id="element-796" />
            </div>
          </div>
          <div className="flex items-end" data-id="element-797">
            <button onClick={handleGenerate} className="w-full sm:w-auto px-6 py-2.5 bg-slate-800 text-white rounded-xl font-medium text-sm hover:bg-slate-700 transition-colors flex items-center justify-center gap-2 h-[42px]" data-id="element-798">
              <SearchIcon className="w-4 h-4" data-id="element-799" />
              Generate
            </button>
          </div>
        </div>

        {hasGenerated && <div className="space-y-8" data-id="element-800">
            {/* Movement of Vehicles Table */}
            <div data-id="element-801">
              <div className="flex items-center gap-2 mb-4" data-id="element-802">
                <TruckIcon className="w-5 h-5 text-brand-teal" data-id="element-803" />
                <h3 className="text-lg font-bold text-slate-900" data-id="element-804">
                  Movement of Vehicles
                </h3>
              </div>
              <div className="border border-slate-200 rounded-xl overflow-hidden" data-id="element-805">
                <div className="overflow-x-auto" data-id="element-806">
                  <table className="w-full text-left text-sm whitespace-nowrap" data-id="element-807">
                    <thead className="bg-slate-50 border-b border-slate-200 text-slate-500" data-id="element-808">
                      <tr data-id="element-809">
                        <th className="px-4 py-3 font-semibold w-12 text-center" data-id="element-810">
                          Sr.
                        </th>
                        <th className="px-4 py-3 font-semibold border-r border-slate-200" data-id="element-811">
                          Date
                        </th>
                        <th className="px-4 py-3 font-semibold text-center" data-id="element-812">
                          Vehicle in Yard
                          <br data-id="element-813" />
                          <span className="text-[10px] font-normal text-slate-400" data-id="element-814">
                            (from prev. day)
                          </span>
                        </th>
                        <th className="px-4 py-3 font-semibold text-center" data-id="element-815">
                          Billable Vehicle
                          <br data-id="element-816" />
                          <span className="text-[10px] font-normal text-slate-400" data-id="element-817">
                            (for days)
                          </span>
                        </th>
                        <th className="px-4 py-3 font-semibold text-center" data-id="element-818">
                          Total Billed
                          <br data-id="element-819" />
                          <span className="text-[10px] font-normal text-slate-400" data-id="element-820">
                            (for a day)
                          </span>
                        </th>
                        <th className="px-4 py-3 font-semibold text-center" data-id="element-821">
                          Vehicle in Yard
                          <br data-id="element-822" />
                          <span className="text-[10px] font-normal text-slate-400" data-id="element-823">
                            (current)
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100" data-id="element-824">
                      {mockData.map((row, idx) => <tr key={`mv-${row.date}`} className="hover:bg-slate-50/50 transition-colors" data-id="element-825">
                          <td className="px-4 py-2.5 text-center text-slate-500 text-xs font-medium" data-id="element-826">
                            {idx + 1}
                          </td>
                          <td className="px-4 py-2.5 font-medium text-slate-800 border-r border-slate-100" data-id="element-827">
                            {row.date}
                          </td>
                          <td className="px-4 py-2.5 text-center" data-id="element-828">
                            <span className="inline-flex items-center justify-center min-w-[32px] h-6 px-2 rounded-md bg-slate-100 text-slate-700 text-xs font-semibold" data-id="element-829">
                              {row.vehicleInYardPrevDay}
                            </span>
                          </td>
                          <td className="px-4 py-2.5 text-center" data-id="element-830">
                            <span className="inline-flex items-center justify-center min-w-[32px] h-6 px-2 rounded-md bg-amber-50 text-amber-700 text-xs font-semibold" data-id="element-831">
                              {row.billableVehicleForDays}
                            </span>
                          </td>
                          <td className="px-4 py-2.5 text-center" data-id="element-832">
                            <span className="inline-flex items-center justify-center min-w-[32px] h-6 px-2 rounded-md bg-green-50 text-green-700 text-xs font-semibold" data-id="element-833">
                              {row.totalBilledForDay}
                            </span>
                          </td>
                          <td className="px-4 py-2.5 text-center" data-id="element-834">
                            <span className="inline-flex items-center justify-center min-w-[32px] h-6 px-2 rounded-md bg-blue-50 text-blue-700 text-xs font-semibold" data-id="element-835">
                              {row.vehicleInYard}
                            </span>
                          </td>
                        </tr>)}
                    </tbody>
                    <tfoot className="bg-slate-50 border-t border-slate-200 font-bold text-slate-900" data-id="element-836">
                      <tr data-id="element-837">
                        <td className="px-4 py-3" data-id="element-838"></td>
                        <td className="px-4 py-3 text-right border-r border-slate-200" data-id="element-839">
                          Total:
                        </td>
                        <td className="px-4 py-3 text-center text-slate-500" data-id="element-840">
                          —
                        </td>
                        <td className="px-4 py-3 text-center text-brand-teal" data-id="element-841">
                          {totals.billableVehicleForDays}
                        </td>
                        <td className="px-4 py-3 text-center text-brand-teal" data-id="element-842">
                          {totals.totalBilledForDay}
                        </td>
                        <td className="px-4 py-3 text-center text-slate-500" data-id="element-843">
                          —
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>

            {/* Existing Collections & Parking Table */}
            <div data-id="element-844">
              <div className="flex items-center gap-2 mb-4" data-id="element-845">
                <LayoutDashboardIcon className="w-5 h-5 text-brand-teal" data-id="element-846" />
                <h3 className="text-lg font-bold text-slate-900" data-id="element-847">
                  Collections & Parking Status
                </h3>
              </div>
              <div className="border border-slate-200 rounded-xl overflow-hidden" data-id="element-848">
                <div className="overflow-x-auto" data-id="element-849">
                  <table className="w-full text-left text-sm whitespace-nowrap" data-id="element-850">
                    <thead className="bg-slate-50 border-b border-slate-200 text-slate-500" data-id="element-851">
                      <tr data-id="element-852">
                        <th rowSpan={2} className="px-3 py-3 font-semibold border-r border-slate-200" data-id="element-853">
                          Date
                        </th>
                        <th rowSpan={2} className="px-3 py-3 font-semibold text-center" data-id="element-854">
                          Entries
                        </th>
                        <th rowSpan={2} className="px-3 py-3 font-semibold text-center" data-id="element-855">
                          Exits
                        </th>
                        <th rowSpan={2} className="px-3 py-3 font-semibold text-center border-r border-slate-200" data-id="element-856">
                          Billing
                        </th>
                        <th colSpan={4} className="px-3 py-2 font-semibold text-center border-b border-slate-200" data-id="element-857">
                          Collection (₹)
                        </th>
                        <th colSpan={3} className="px-3 py-2 font-semibold text-center border-l border-slate-200 border-b border-slate-200" data-id="element-858">
                          Parking Status
                        </th>
                      </tr>
                      <tr className="bg-slate-100/50 text-xs text-slate-400" data-id="element-859">
                        <th className="px-3 py-1.5 text-center font-semibold" data-id="element-860">
                          Cash
                        </th>
                        <th className="px-3 py-1.5 text-center font-semibold" data-id="element-861">
                          QR
                        </th>
                        <th className="px-3 py-1.5 text-center font-semibold" data-id="element-862">
                          Coupon
                        </th>
                        <th className="px-3 py-1.5 text-center font-semibold border-r border-slate-200" data-id="element-863">
                          Total
                        </th>
                        <th className="px-3 py-1.5 text-center font-semibold" data-id="element-864">
                          Available
                        </th>
                        <th className="px-3 py-1.5 text-center font-semibold" data-id="element-865">
                          Consumed
                        </th>
                        <th className="px-3 py-1.5 text-center font-semibold" data-id="element-866">
                          Remaining
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100" data-id="element-867">
                      {mockData.map(row => {
                    const rowTotal = row.cashCollection + row.qrCollection + row.couponCollection;
                    return <tr key={row.date} className="hover:bg-slate-50/50 transition-colors" data-id="element-868">
                            <td className="px-3 py-2.5 font-medium text-slate-800 border-r border-slate-100" data-id="element-869">
                              {row.date}
                            </td>
                            <td className="px-3 py-2.5 text-center" data-id="element-870">
                              <span className="inline-flex items-center justify-center min-w-[28px] h-6 px-2 rounded-md bg-blue-50 text-blue-700 text-xs font-semibold" data-id="element-871">
                                {row.noOfEntry}
                              </span>
                            </td>
                            <td className="px-3 py-2.5 text-center" data-id="element-872">
                              <span className="inline-flex items-center justify-center min-w-[28px] h-6 px-2 rounded-md bg-green-50 text-green-700 text-xs font-semibold" data-id="element-873">
                                {row.noOfExit}
                              </span>
                            </td>
                            <td className="px-3 py-2.5 text-center border-r border-slate-100" data-id="element-874">
                              <span className="inline-flex items-center justify-center min-w-[28px] h-6 px-2 rounded-md bg-amber-50 text-amber-700 text-xs font-semibold" data-id="element-875">
                                {row.noOfBilling}
                              </span>
                            </td>
                            <td className="px-3 py-2.5 text-right text-slate-700 text-xs" data-id="element-876">
                              ₹{row.cashCollection.toLocaleString()}
                            </td>
                            <td className="px-3 py-2.5 text-right text-slate-700 text-xs" data-id="element-877">
                              ₹{row.qrCollection.toLocaleString()}
                            </td>
                            <td className="px-3 py-2.5 text-right text-slate-700 text-xs" data-id="element-878">
                              ₹{row.couponCollection.toLocaleString()}
                            </td>
                            <td className="px-3 py-2.5 text-right font-bold text-slate-900 text-xs border-r border-slate-100" data-id="element-879">
                              ₹{rowTotal.toLocaleString()}
                            </td>
                            <td className="px-3 py-2.5 text-center text-slate-600 text-xs" data-id="element-880">
                              {row.totalParkingAvailable}
                            </td>
                            <td className="px-3 py-2.5 text-center" data-id="element-881">
                              <span className="inline-flex items-center justify-center min-w-[28px] h-6 px-2 rounded-md bg-rose-50 text-rose-700 text-xs font-semibold" data-id="element-882">
                                {row.consumedArea}
                              </span>
                            </td>
                            <td className="px-3 py-2.5 text-center" data-id="element-883">
                              <span className="inline-flex items-center justify-center min-w-[28px] h-6 px-2 rounded-md bg-emerald-50 text-emerald-700 text-xs font-semibold" data-id="element-884">
                                {row.remainingParkingWard}
                              </span>
                            </td>
                          </tr>;
                  })}
                    </tbody>
                    <tfoot className="bg-slate-50 border-t border-slate-200 font-bold text-slate-900" data-id="element-885">
                      <tr data-id="element-886">
                        <td className="px-3 py-3 text-right border-r border-slate-200" data-id="element-887">
                          Total:
                        </td>
                        <td className="px-3 py-3 text-center text-brand-teal" data-id="element-888">
                          {totals.noOfEntry}
                        </td>
                        <td className="px-3 py-3 text-center text-brand-teal" data-id="element-889">
                          {totals.noOfExit}
                        </td>
                        <td className="px-3 py-3 text-center text-brand-teal border-r border-slate-200" data-id="element-890">
                          {totals.noOfBilling}
                        </td>
                        <td className="px-3 py-3 text-right text-brand-teal text-xs" data-id="element-891">
                          ₹{totals.cashCollection.toLocaleString()}
                        </td>
                        <td className="px-3 py-3 text-right text-brand-teal text-xs" data-id="element-892">
                          ₹{totals.qrCollection.toLocaleString()}
                        </td>
                        <td className="px-3 py-3 text-right text-brand-teal text-xs" data-id="element-893">
                          ₹{totals.couponCollection.toLocaleString()}
                        </td>
                        <td className="px-3 py-3 text-right text-brand-teal text-xs border-r border-slate-200" data-id="element-894">
                          ₹{grandTotal.toLocaleString()}
                        </td>
                        <td colSpan={3} className="px-3 py-3" data-id="element-895"></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>}
      </motion.div>

      {/* A4 Print Layout */}
      {hasGenerated && <div id="print-a4-report" className="hidden print:block bg-white text-black p-8" data-id="element-896">
          {/* Print Header */}
          <div className="text-center mb-6 border-b-2 border-black pb-4" data-id="element-897">
            <h1 className="text-2xl font-bold tracking-tight mb-1" data-id="element-898">
              ERPLogiPark
            </h1>
            <p className="text-sm text-gray-600 mb-3" data-id="element-899">
              Plot No. 45, Logistics Hub, Sector 18, Industrial Area, Bangalore
              - 560100
            </p>
            <h2 className="text-xl font-bold uppercase tracking-wider mb-1" data-id="element-900">
              Management Information System (MIS) Report
            </h2>
            <p className="text-sm font-medium" data-id="element-901">
              Period: {startDate} to {endDate}
            </p>
          </div>

          {/* Print: Movement of Vehicles */}
          <h3 className="text-sm font-bold uppercase border-b border-gray-400 pb-1 mb-3" data-id="element-902">
            Movement of Vehicles
          </h3>
          <table className="w-full text-left text-[10px] border-collapse mb-8" data-id="element-903">
            <thead data-id="element-904">
              <tr className="border-b-2 border-black" data-id="element-905">
                <th className="py-2 px-1 font-bold text-center w-8" data-id="element-906">Sr.</th>
                <th className="py-2 px-1 font-bold border-r border-gray-400" data-id="element-907">
                  Date
                </th>
                <th className="py-2 px-1 font-bold text-center" data-id="element-908">
                  Veh. in Yard (Prev. Day)
                </th>
                <th className="py-2 px-1 font-bold text-center" data-id="element-909">
                  Billable Veh. (Days)
                </th>
                <th className="py-2 px-1 font-bold text-center" data-id="element-910">
                  Total Billed (Day)
                </th>
                <th className="py-2 px-1 font-bold text-center" data-id="element-911">
                  Veh. in Yard (Current)
                </th>
              </tr>
            </thead>
            <tbody data-id="element-912">
              {mockData.map((row, index) => <tr key={`pmv-${row.date}`} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} data-id="element-913">
                  <td className="py-1.5 px-1 border-b border-gray-200 text-center" data-id="element-914">
                    {index + 1}
                  </td>
                  <td className="py-1.5 px-1 border-b border-gray-200 font-medium border-r border-gray-200" data-id="element-915">
                    {row.date}
                  </td>
                  <td className="py-1.5 px-1 border-b border-gray-200 text-center" data-id="element-916">
                    {row.vehicleInYardPrevDay}
                  </td>
                  <td className="py-1.5 px-1 border-b border-gray-200 text-center" data-id="element-917">
                    {row.billableVehicleForDays}
                  </td>
                  <td className="py-1.5 px-1 border-b border-gray-200 text-center" data-id="element-918">
                    {row.totalBilledForDay}
                  </td>
                  <td className="py-1.5 px-1 border-b border-gray-200 text-center" data-id="element-919">
                    {row.vehicleInYard}
                  </td>
                </tr>)}
            </tbody>
            <tfoot data-id="element-920">
              <tr className="border-t-2 border-black font-bold" data-id="element-921">
                <td className="py-2 px-1" data-id="element-922"></td>
                <td className="py-2 px-1 text-right border-r border-gray-400" data-id="element-923">
                  TOTAL:
                </td>
                <td className="py-2 px-1 text-center" data-id="element-924">—</td>
                <td className="py-2 px-1 text-center" data-id="element-925">
                  {totals.billableVehicleForDays}
                </td>
                <td className="py-2 px-1 text-center" data-id="element-926">
                  {totals.totalBilledForDay}
                </td>
                <td className="py-2 px-1 text-center" data-id="element-927">—</td>
              </tr>
            </tfoot>
          </table>

          {/* Print: Collections & Parking */}
          <h3 className="text-sm font-bold uppercase border-b border-gray-400 pb-1 mb-3" data-id="element-928">
            Collections & Parking Status
          </h3>
          <table className="w-full text-left text-[10px] border-collapse" data-id="element-929">
            <thead data-id="element-930">
              <tr className="border-b-2 border-black" data-id="element-931">
                <th rowSpan={2} className="py-2 pr-1 font-bold border-r border-gray-400" data-id="element-932">
                  Date
                </th>
                <th rowSpan={2} className="py-2 px-1 font-bold text-center" data-id="element-933">
                  Entries
                </th>
                <th rowSpan={2} className="py-2 px-1 font-bold text-center" data-id="element-934">
                  Exits
                </th>
                <th rowSpan={2} className="py-2 px-1 font-bold text-center border-r border-gray-400" data-id="element-935">
                  Billing
                </th>
                <th colSpan={4} className="py-1 px-1 font-bold text-center border-b border-gray-300" data-id="element-936">
                  Collection (₹)
                </th>
                <th colSpan={3} className="py-1 px-1 font-bold text-center border-l border-gray-400 border-b border-gray-300" data-id="element-937">
                  Parking Status
                </th>
              </tr>
              <tr className="border-b border-gray-300" data-id="element-938">
                <th className="py-1 px-1 text-center font-bold" data-id="element-939">Cash</th>
                <th className="py-1 px-1 text-center font-bold" data-id="element-940">QR</th>
                <th className="py-1 px-1 text-center font-bold" data-id="element-941">Coupon</th>
                <th className="py-1 px-1 text-center font-bold border-r border-gray-400" data-id="element-942">
                  Total
                </th>
                <th className="py-1 px-1 text-center font-bold" data-id="element-943">Avail.</th>
                <th className="py-1 px-1 text-center font-bold" data-id="element-944">Used</th>
                <th className="py-1 px-1 text-center font-bold" data-id="element-945">Remain.</th>
              </tr>
            </thead>
            <tbody data-id="element-946">
              {mockData.map((row, index) => {
            const rowTotal = row.cashCollection + row.qrCollection + row.couponCollection;
            return <tr key={row.date} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} data-id="element-947">
                    <td className="py-1.5 pr-1 border-b border-gray-200 font-medium border-r border-gray-200" data-id="element-948">
                      {row.date}
                    </td>
                    <td className="py-1.5 px-1 border-b border-gray-200 text-center" data-id="element-949">
                      {row.noOfEntry}
                    </td>
                    <td className="py-1.5 px-1 border-b border-gray-200 text-center" data-id="element-950">
                      {row.noOfExit}
                    </td>
                    <td className="py-1.5 px-1 border-b border-gray-200 text-center border-r border-gray-200" data-id="element-951">
                      {row.noOfBilling}
                    </td>
                    <td className="py-1.5 px-1 border-b border-gray-200 text-right" data-id="element-952">
                      {row.cashCollection.toLocaleString()}
                    </td>
                    <td className="py-1.5 px-1 border-b border-gray-200 text-right" data-id="element-953">
                      {row.qrCollection.toLocaleString()}
                    </td>
                    <td className="py-1.5 px-1 border-b border-gray-200 text-right" data-id="element-954">
                      {row.couponCollection.toLocaleString()}
                    </td>
                    <td className="py-1.5 px-1 border-b border-gray-200 text-right font-bold border-r border-gray-200" data-id="element-955">
                      {rowTotal.toLocaleString()}
                    </td>
                    <td className="py-1.5 px-1 border-b border-gray-200 text-center" data-id="element-956">
                      {row.totalParkingAvailable}
                    </td>
                    <td className="py-1.5 px-1 border-b border-gray-200 text-center" data-id="element-957">
                      {row.consumedArea}
                    </td>
                    <td className="py-1.5 px-1 border-b border-gray-200 text-center" data-id="element-958">
                      {row.remainingParkingWard}
                    </td>
                  </tr>;
          })}
            </tbody>
            <tfoot data-id="element-959">
              <tr className="border-t-2 border-black font-bold" data-id="element-960">
                <td className="py-2 pr-1 text-right border-r border-gray-400" data-id="element-961">
                  TOTAL:
                </td>
                <td className="py-2 px-1 text-center" data-id="element-962">{totals.noOfEntry}</td>
                <td className="py-2 px-1 text-center" data-id="element-963">{totals.noOfExit}</td>
                <td className="py-2 px-1 text-center border-r border-gray-400" data-id="element-964">
                  {totals.noOfBilling}
                </td>
                <td className="py-2 px-1 text-right" data-id="element-965">
                  {totals.cashCollection.toLocaleString()}
                </td>
                <td className="py-2 px-1 text-right" data-id="element-966">
                  {totals.qrCollection.toLocaleString()}
                </td>
                <td className="py-2 px-1 text-right" data-id="element-967">
                  {totals.couponCollection.toLocaleString()}
                </td>
                <td className="py-2 px-1 text-right border-r border-gray-400" data-id="element-968">
                  {grandTotal.toLocaleString()}
                </td>
                <td colSpan={3} className="py-2 px-1" data-id="element-969"></td>
              </tr>
            </tfoot>
          </table>

          {/* Print Footer */}
          <div className="mt-12 text-xs text-gray-500 flex justify-between" data-id="element-970">
            <p data-id="element-971">Generated on: {new Date().toLocaleString()}</p>
            <p data-id="element-972">Page 1 of 1</p>
          </div>
        </div>}
    </div>;
}